<template>
  <div class="layout-wrapper" :class="containerClass">
    <AppTopBar v-if="configLayout['appTopBar']" @menu-toggle="onMenuToggleClick"
      @report-menu-toggle="onReportMenuToggleClick" :newTopbarColor="newTopbarColor" />
    <AppMenuComponent v-if="configLayout['appMenuComponent']" :active="sidebarActive"
      @menuitem-click="sidebarActive = true" @hide-sidebar="sidebarActive = false" />
    <AppMenuReport v-if="configLayout['appMenuReport']" :active="reportSidebarActive"
      @hide-sidebar="reportSidebarActive = false" @show-sidebar="onReportMenuToggleClick" />
    <AppConfig v-if="configLayout['appConfig']" @change-theme="changeTheme" :theme="theme"
      @change-color="changeTopbarColor" />
    <!--<AppProfile v-if=""/>-->
    <div class="main-layout">
      <router-view />
    </div>
    <AppFooter v-if="configLayout['appFooter']" />
    <ErrorDialog :error="store.getters.error" @clearError="store.commit('CLEAR_ERROR')" />
    <News />
    <Toast :baseZIndex="999" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import AppConfig from "./AppConfig.vue";
import AppTopBar from "./AppTopbar.vue";
import AppFooter from "./AppFooter.vue";
import AppMenuComponent from "./AppMenuComponent.vue";
import AppMenuReport from "./AppMenuReport.vue";
import News from "../news/News.vue";
import EventBus from "../EventBus";

const { proxy } = getCurrentInstance();
const store = useStore();
const route = useRoute();
const router = useRouter();
const toast = useToast();

const layoutMode = ref("static");
const layoutColorMode = ref("dark");
const theme = ref("saga-blue");
const staticMenuInactive = ref(false);
const overlayMenuActive = ref(false);
const mobileMenuActive = ref(false);
const sidebarActive = ref(false);
const reportSidebarActive = ref(false);
const configLayout = ref(store.getters.config("layouts"));
const newTopbarColor = ref(null);
let menuClick = false;

const containerClass = computed(() => [
  "layout-wrapper",
  {
    "layout-overlay": layoutMode.value === "overlay",
    "layout-static": layoutMode.value === "static",
    "layout-static-sidebar-inactive": staticMenuInactive.value && layoutMode.value === "static",
    "layout-overlay-sidebar-active": overlayMenuActive.value && layoutMode.value === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive.value,
    "p-input-filled": proxy?.$appState?.inputStyle === "filled",
    "p-ripple-disabled": proxy?.$primevue?.ripple === false,
  },
]);

const sidebarClass = computed(() => [
  "layout-sidebar",
  {
    "layout-sidebar-dark": layoutColorMode.value === "dark",
    "layout-sidebar-light": layoutColorMode.value === "light",
  },
]);



watch(route, () => {
  menuClick = false;
  toast.removeAllGroups();
});

const servicesMap = {};

function loadServices(services) {
  for (let index = 0; index < services.length; index++)
    loadService(services, index);
}

function changeTopbarColor() {
  if (localStorage.topbarColor) newTopbarColor.value = localStorage.topbarColor;
  else newTopbarColor.value = null;
}

function loadService(services, index, parent = false) {
  const serviceKey = services[index].options + "Service";
  if (
    servicesMap[serviceKey] &&
    (!services[index].parent || parent)
  ) {
    servicesMap[serviceKey]
      .getData()
      .then((data) => {
        store.dispatch(
          "set" + store.getters.upperCaseLetter(services[index].options),
          data
        );
        for (let i = 0; i < services.length; i++)
          if (services[i].parent === services[index].id)
            loadService(services, i, true);
      })
      .catch((er) => {
        store.commit("SET_ERROR", {
          er: er?.response ?? er,
          source: ["MainLayout", "loadService"],
        });
      });
  }
}

function createServices(services, pas, login) {
  for (const item of services) {
    if (item.serviceName) {
      let service = store.getters.nameToService(
        item.serviceName,
        login,
        pas,
        item.entityName,
        item.entitySpec
      );
      if (service) servicesMap[item.options + "Service"] = service;
    }
  }
}

function loadTheme() {
  if (localStorage.theme && localStorage.theme !== theme.value) {
    let obj = {
      theme: localStorage.theme,
      dark: Boolean(localStorage.dark) || undefined,
    };
    changeTheme(obj);
  }
}

function changeTheme(event) {
  let themeElement = document.getElementById("theme-link");
  themeElement.setAttribute(
    "href",
    themeElement.getAttribute("href").replace(theme.value, event.theme)
  );
  theme.value = event.theme;
  EventBus.emit("change-theme", event);
  if (event.dark !== undefined && proxy?.$appState) {
    proxy.$appState.darkTheme = event.dark;
  }
  if (event.theme.startsWith("md")) {
    if (proxy?.$primevue?.config) {
      proxy.$primevue.config.ripple = true;
    }
  }
  localStorage.theme = theme.value;
  if (proxy?.$primevue?.config) {
    localStorage.ripple = proxy.$primevue.config.ripple;
  }
  if (event.dark === undefined) localStorage.removeItem("dark");
  else localStorage.dark = event.dark;
}

function onMenuToggleClick() {
  sidebarActive.value = true;
}

function onReportMenuToggleClick() {
  reportSidebarActive.value = true;
}

onMounted(() => {
  loadTheme();
  const services = store.getters.config("services");
  createServices(services, null, null);
  loadServices(services);
});
</script>
